import { format } from 'date-fns'
import { useGetDataAssetActivityLogByIds } from './useGetDataAssetActivityLogByIds'
import { ActivityLogV2Content } from './ActivityLogV2Content'
import { useDownloadFile } from '../../TemplatesV2/useDownloadFile'
import { MessagesStorageStorageFileType } from '@/util/enums'

export type ActivityLogV2Props = {
  entityId: number
  dataAssetId: number
}

export function ActivityLogV2({ entityId, dataAssetId }: ActivityLogV2Props) {
  const { data: activityLog } = useGetDataAssetActivityLogByIds({ entityId, dataAssetId })
  const { mutate: downloadFile, isPending } = useDownloadFile()

  const firstActivity = activityLog[0]
  const lastActivity = activityLog[activityLog.length - 1]

  if (!firstActivity || !lastActivity) return <div>No activity</div>
  const { user, date, url } = firstActivity
  const updatedText = `Updated ${user ? `by ${user} on` : ''} ${format(new Date(date), 'PPP')}`
  // const NextAction = renderNextAction(lastActivity)
  const handleDownloadTemplate = () => {
    if (!url) return
    downloadFile({ url, fileName: firstActivity.file_name, fileType: MessagesStorageStorageFileType.Result })
  }
  return (
    <ActivityLogV2Content
      activityLog={activityLog}
      lastActivity={lastActivity}
      url={url}
      updatedText={updatedText}
      handleDownloadTemplate={handleDownloadTemplate}
      isPending={isPending}
      entityId={entityId}
      dataAssetId={dataAssetId}
    />
  )
}
